import { render, staticRenderFns } from "./createOrEditSession.vue?vue&type=template&id=54f9a4b9"
import script from "./createOrEditSession.vue?vue&type=script&lang=js"
export * from "./createOrEditSession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports